export const StudyTranslations = {
  'eng': {
    insufficientData: 'Insufficient data',
    newStudyWarning: 'Items cannot be changed after creating a study',
    recentYears: 'Last two years',
    formerYears: 'Before last tow years',
    showOldYears: 'Show former years',
    showMonthlyCashFlow: 'Show cash flow on a monthly basis',
    import: 'Import',
    balanceImport: 'Balance import',
    profitAndLossImport: 'Profit and loss import',
    clearImport: 'Clear data',
    generateWithAi: "Generate with AI",
    generating: "Generating...",
    source: 'Source',
    sourceOfFunding: 'Source of funding',
    systemSettings: 'System settings',
    initialInvestmentFail: 'Initial investment sum must be equal to investment sources sum!',
    initialInvestmentTrue: 'Initial investment sum is equal to investment sources sum',
    investmentStudy: 'Investment study',
    newInvestmentStudy: 'New investment study',
    addInvestmentStudy: 'Add investment study',
    projectDefining: 'Project defining',
    newProjectDefining: 'New project defining',
    addProjectDefining: 'Add project defining',
    financeAnalysis: 'Financial analysis',
    newFinanceAnalysis: 'New financial analysis',
    addFinanceAnalysis: 'Add financial analysis',
    shortBalance: 'Short RDG & balance',
    newShortBalance: 'New short RDG & balance',
    addShortBalance: 'Add short RDG & balance',
    loanTools: 'Loan',
    newLoan: 'New loan',
    addLoan: 'Add loan',
    projectRealization: 'Project realization',
    newProjectRealization: 'new  project realization',
    addProjectRealization: 'Add project realization',
    name: 'Name of the study',
    year: 'Year',
    years: 'Years',
    yearsAmount: 'Number of business years',
    startYear: 'Calendar year of the first business year',
    investmentStudyCreated: 'Investment study was created',
    projectDefiningCreated: 'Project defining was created',
    studyDeleted: 'Study deleted',
    studiesList: 'Studies list',
    financeList: 'Finance analysis list',
    balanceList: 'Short balance list',
    loanList: 'Loan list',
    realizationList: 'Project realization list',
    type: 'Type',
    studyType: 'Type',
    createdAt: 'Created at',
    contentUpdatedAt: 'Updated at',
    intro: 'Intro',
    welcomeIntro: 'Welcome to investment study',
    introDescription: 'An investment study is an e-tool to support entrepreneurs, project managers, business owners, and others.',
    reviewInvestmentStudy: 'Review investment studies',
    reviewInvestmentStudyL: 'REVIEW INVESTMENT STUDIES ',
    startTheGuide: 'Start the interactive guide',
    startGuide: 'START THE GUIDE',
    defineNewProjects: 'Define new projects',
    defineNewProjectsL: 'DEFINE NEW PROJECTS ',

    reviewEarlierProjects: 'Review earlier projects',
    addNewStudy: 'Add new study',
    addNewStudyL: 'ADD NEW STUDY',
    review: 'REVIEW',
    summary: 'Project summary',
    confirmDirtyForm: 'You have unsaved changes, are you sure you want to proceed?',
    currency: 'Currency',
    kn: 'HRK',
    eur: 'EUR',
    eng: 'English',
    cro: 'Croatian',
    tableName: 'Name',
    tableYears: 'Years (Amount in',
    rate: 'Rate',
    purchaseValue: 'Purchase value',
    startingMonth: 'Starting month',
    startingYear: 'Starting year',
    residue: 'Residue',
    exportTable: 'Export Table',
    netBookValue: 'Net book value',
    share: 'Share',
    amount: 'Amount',
    amountsTo: 'Amounts',
    remarkMarketingReportOne: '*Note: Planned costs of marketing activities must be included in table 9.7. Cost calculation and price calculation under the item "Service costs" which is offered in the drop-down menu under the item "Marketing activities".',
    remarkMarketingReportTwo: '*Note: The marketing report represents the monthly elaboration of the costs of marketing activities for the first year specified in the Plan of marketing activities and cost budget.',

    //Opis poduzetnika / nositelja projekta
    entrepreneurDescription: 'Entrepreneur / project leader description',
    entrepreneurInfo: 'Entrepreneur / project leader info',
    entrepreneurBusinessSubject: 'Entrepreneur business subject',
    entrepreneurCurrentAssets: 'Entrepreneur current assets',
    recentBusinessFinancialAnalysis: 'Recent business financial analysis',
    potentialDevelopmentRating: 'Potential development rating',

    info: 'Info',
    projectDescription: 'Project description',
    initialInvestment: 'Initial investment',
    employees: 'Employees',
    qualificationsStructure: 'Employees structure',
    level_1: 'Eko level 1',
    level_2: 'Eko level 2',
    level_3: 'Eko level 3',
    level_4: 'Eko level 4',
    level_5: 'Eko level 5',
    level_6: 'Eko level 6',
    level_7: 'Eko level 7',
    level_8: 'Eko level 8',
    addSector: 'Add sector',
    products: 'Products',
    services: 'Services',
    newProduct: 'New product',
    addProduct: 'Add product',
    product: 'Product',
    service: 'Service',
    marketingActivity: 'Marketing activity',

    //Market analysis
    marketAnalysis: 'Market analysis',
    procurementMarket: 'Sales market',
    salesMarket: 'Procurement market',
    marketAnalysisSummary: 'Market analysis summary and income estimation',

    employeesDynamicAndStructure: 'Employees dynamic and structure',
    wantedStaffAnalysis: 'Wanted staff analysis',
    employeesStructure: 'Employees structure',
    humanResourcesReport: 'Human resources report',
    yearSalaryBudget: 'Year salary budget',
    employeesCount: 'Employees count',
    sumStaffExpenses: 'Sum staff expenses',
    averageMonthlySalary: 'Average monthly gross salary II',
    totalEmployees: 'Total Employees',
    employeesNumber: 'Number of employees',
    grossSalary: 'Gross salary 2',
    numberOfPeople: 'Number of people',
    numberFullTime: 'Full time measurement',
    initialState: 'Inital state',
    initialStateDesc: 'enter the number of employees on 01.01.',
    employed: 'Employed',
    employedDesc: 'enter the planned number of new employees during the period 01.01-31.12',
    staffLeft: 'Employees left',
    staffLeftDesc: 'enter the planned number of employees who will leave the company during the period 01.01-31.12\n',
    description: 'Description',
    sectorName: 'Sector name',
    descriptionDesc: 'Refers to Department / Education / Occupation / Job Title, or similar',
    finalState: 'Final state',
    explanation: 'Explanation',
    EKO: 'European Qualifications Framework - EQF as the main foundation of lifelong learning is an initiative of the European Union that serves to recognize national qualifications in all European countries that are acquired through all forms of education from primary education to higher education. EQF describes the qualifications that are acquired when a student completes a certain level of education. They are defined through learning outcomes that describe what the student knows, understands and can do at the end of the learning process.',
    //9. Ekonomsko-financijska analiza
    economicFinancialAnalysis: 'Economic financial analysis',
    //Predračunska vrijednost ulaganja u dugotrajnu imovinu
    fixedAssetsEstimateInvestment: 'Fixed assets estimate investment',
    nonMaterialEstimateInvestment: 'Non material estimate investment',
    materialEstimateInvestment: 'Material estimate investment',
    //Predračunska vrijednost ulaganja u kratkotrajnu imovinu
    currentAssetsEstimateInvestment: 'Current assets estimate investment',
    workingCapitalEstimateInvestment: 'Working capital estimate investment',
    //Ukupna predračunska vrijednost ulaganja
    sumEstimateInvestment: 'Sum estimate investment',
    fixedAndCurrentAssetsInvestment: 'Fixed and current assets investment structure',
    basicInstrumentsInvestment: 'Basic instruments and working capital investment',
    yearInvestmentBudget: 'Investment budget by year',
    nonMaterialInstruments: 'Nonmaterial instruments',
    materialInstruments: 'Material instruments',
    workingCapitalInstruments: 'Working capital instruments',
    sourceOfGrants: 'Source of grants',
    shareOfGrants: 'Share of grants',
    totalProjectCosts: 'Total project costs',
    //Izvori financiranja i kreditni uvjeti
    financeSourcesAndCredit: 'Finace sources',
    financeSources: 'Finance sources',
    yearFinanceSources: 'Finance sources by year',
    inputs: 'Inputs',
    requestedLoanAmount: 'Loan amount',
    interestRate: 'Iterest rate',
    repaymentYears: 'Repayment years',
    defermentYears: 'Deferment years',
    numberOfYears: 'number of years',
    quarter: 'Quarter',
    loanAmount: 'Loan amount',
    repayment: 'Repayment',
    yearlyInterest: 'Yearly Interest',
    yearlyAnnuity: 'Yearly annuity',
    //Obračun kreditnih obveza
    creditCalculation: 'Credit terms and calculation',
    creditRepaymentPlan: 'Credit repayment plan',
    //Proračun amortizacije
    amortizationBudget: 'Amortization budget',
    amortization: 'Amortization',
    amortizationLongtermAssets: 'Long-term assets from project',
    pastAssetsOutProject: 'Past assets not acquired through the project',
    futureAssetsOutProject: 'Future assets not acquired through the project',
    //Proračun troškova i amortizacija cijena
    expensesBudgetAndPrices: 'Expenses budget and prices calculation',
    sumProductionExpenses: 'Production sum expenses calculation',
    planedAmount: 'Planed amount per year',
    planedCostPerUnit: 'Planed cost per unit per year',
    planedSumAmount: 'Planed total expense per year',
    //Formiranje ukupnih prihoda
    totalIncome: 'Total income',
    fullIncome: 'Total income',
    fullIncomeCalculation: 'Total income calculation',
    //Formiranje ukupnih rashoda
    totalExpense: 'Total expenses',
    fullExpense: 'Total expenses',
    totalExpenseCalculation: 'Total expenses calculation',
    //Projekcija računa dobiti i gubitka
    profitAndLossProjection: 'Profit and loss account projection',
    profitAndLoss: 'Profit and loss account',
    expenseIncomeType: 'Income/expense type',
    businessIncome: 'Operating income',
    salesIncome: 'Sales revenue',
    otherBusinessIncome: 'Other business income',
    otherIncome: 'Other income',
    otherExpense: 'Other expenses',
    otherBusinessExpense: 'other operating expenses',
    grantRevenues: 'Grants revenue',
    financialIncome: 'Financial revenue',
    profitShare: 'Share of profits from associates',
    otherProfits: 'Outstanding - other profits',
    lossShare: 'Share of losses from associates',
    otherLosses: 'Outstanding - other losses',
    businessExpense: 'Operating expenses',
    stockDifference: 'Increase in stocks of work in progress and finished goods',
    valueBalancing: 'Value adjustment',
    profit: 'Profit or loss before tax',
    profitAfterTax: 'Profit or loss for the period',
    profitOrLossBeforeTax: 'Profit/loss before tax',
    profitOrLossAfterTax: 'Profit/loss after tax',
    lossBeforeTax: 'Loss before tax',
    lossAfterTax: 'Loss after tax',
    netProfitLossPeriod: 'Net profit/loss period',
    profitPeriod: 'Profit period',
    lossPeriod: 'Loss period',
    expenseType: 'Expense type',
    loanInterests: 'Loan interests',
    negativeExchangeRates: 'Negative exchange rates',
    otherFinancialExpenses: 'Other financial expenses',
    incomeType: 'Income type',
    productRevenue: 'Product revenue',
    servicesRevenue: 'Services revenue',
    salesGoodsRevenue: 'Revenue from sales of goods',
    interestIncome: 'Interest income',
    foreignExchangeIncome: 'Foreign exchange income',
    incomeSecurities: 'Income securities',
    otherFinancialIncome: 'Other financial income',

    //Projekcija potrebnih obrtnih sredstava
    currentAssetsProjection: 'Projection of needed current assets',
    items: 'Items',
    daysOutstanding: 'Days outstanding',
    turnover: "Turnover",
    productStocks: 'Product stocks',
    productStocksGoods: '(goods)',
    stocks: 'Stocks',
    rawMaterials: 'Raw materials',
    tradeReceivables: 'Trade receivables',
    money: 'Money',
    otherBusinessExpenses: 'Other business expenses',
    pretax: 'Pre-tax',
    taxDays: 'VAT - in issued invoices',
    sourcesOfBusiness: 'Sources of business',
    suppliers: 'Suppliers',
    suppliersOverdue: 'Suppliers - overdue',
    laborCost: 'Labor cost',
    laborCostSalaries: 'Labor cost - salaries',
    interest: 'Interest',
    tax: 'Tax',
    difference: 'Difference (1-2)',
    workingCapitalInvestment: 'Working capital investment',
    availableWorkingCapital: 'Available working capital',

    //Projekcija novčanog toka

    financialFlow: 'Financial flow',
    finance: "Financial flow",
    economicFlow: 'Economic flow',
    economic: 'Economic flow',
    //Balance projection
    balanceProjection: 'Balance projection',
    balance: 'Balance',
    importBalanceRDG: 'Import balance and RDG to get static efficiency rating',
    unpaidCapitalClaims: 'Unpaid capital claims',
    claims: 'Long-term claims',
    claimsDays: 'Long-term claims',
    shortTermClaims: 'Short-term claims',
    delayedTaxAssets: 'Delayed tax assets',
    financialAssets: 'Financial assets',
    shortTermFinancialAssets: 'Financial assets',
    longTermFinancialAssets: 'Financial assets',
    futurePaidExpenses: 'Future paid expenses',
    capitalReserves: 'Capital reserves',
    capitalAndReserves: 'Capital and Reserves',
    subtractionReturns: 'Subtraction returns',
    revalorizationReserves: 'Revalorization reserves',
    justValueReserves: 'Just value reserves',
    minortyInterest: 'Minority interest',
    reservations: 'Reservations',
    balanceReservations: 'Reservation',
    pensionsReserves: 'Reserves for pensions, severance pay and similar liabilities',
    taxReserves: 'Tax reserves',
    otherReserves: 'other reserves',
    otherLongTermObligations: 'Other long-term obligations',
    delayedExpensesPayments: 'Delayed expenses payments',
    extraBalance: 'Extra balance',
    activeExtraBalance: 'Active extra balance',
    passiveExtraBalance: 'Passive extra balance',
    position: 'Position',
    assets: 'Assets',
    fullAssets: 'Assets',
    liabilities: 'Liabilities',
    adittionalCoefficientOfFinancialStabilty: 'Additional coefficient of financial stability',
    indebtednessFactor: 'Indebtedness factor',
    accumulatedAmortization: 'Accumulated amortization',
    productMaterialGoodsStocks: 'Product, material, goods stocks',
    stockDays: 'Product, material, goods stocks',
    productStock: 'Product stock',
    subCapital: 'Subscribed capital',
    subscribedCapital: 'Subscribed capital',
    earningLossCarried: 'Retained earnings or carried loss',
    keptProfitOrTransferredLoss: 'Retained earnings or carried loss',
    retainedEarnings: 'Retained earnings',
    keptProfit: 'Retained earnings',
    lossCarried: 'Loss carried',
    transferredLoss: 'Loss carried',
    profitLossByYear: 'Profit / loss for the business year',
    balanceProfit: 'Profit / loss for the business year',
    profitBusinessYear: 'Profit for the business year',
    lossBusinessYear: 'Loss for the business year',
    longTermObligations: 'Long-term obligations',
    bankLiabilities: 'Bank liabilities',
    bankDebt: 'Bank liabilities',
    bankAndOtherObligations: 'Liabilities to banks and other financial institutions',
    defferedPaymentOfExp: 'Deffered payment of expenses and income of the future period',
    loanObligations: 'Obligations for loans, deposits and other',
    shorttermLiabilities: 'Short-term liabilities',
    shortTermObligations: 'Short-term liabilities',
    suppliersDays: 'Supplier liabilities',
    supplierCommitments: 'Supplier liabilities',
    employeeCommitments: 'Employee liabilities',
    employeesObligations: 'Employee liabilities',
    otherShorttermCommitments: 'Other short-term liabilities',
    otherShortTermObligations: 'Other short-term liabilities',
    //Postojeća imovina poduzetnika
    availableAssetsSpec: 'Available assets specification',
    previousAssetsNotProject: 'Assets from the previous period not acquired through the project',
    projectHolder: 'Podaci o Investitoru / Nositelju projekta',

    estimateValues: 'Estimate values',
    addItem: 'Add item',
    // nonMaterialEstimateInvestment: 'Non material estimate investment',
    researchAndDevelopment: 'Research and development',
    concessions: 'Concessions',
    patents: 'Patents',
    phoneServices: 'Phone services',
    brands: 'Brands',
    software: 'Software',
    // materialEstimateInvestment: 'Material estimate investment',
    land: 'Land',
    buildings: 'Buildings',
    facilities: 'Facilities',
    equipment: 'Equipment',
    tools: 'Tools',
    inventory: 'Inventory',
    transport: 'Transport',
    plants: 'Biological assets - plants',
    animals: 'Biological assets - animals',
    externalServices: 'External services',
    material: 'Material',
    intellectualServices: 'Intellectual services',
    otherExternalServices: 'Other external services',
    representation: 'Representation',
    procurement: 'Procurement',
    nonMaterialStructure: 'Non material assets structure',
    materialStructure: 'Material assets structure',
    workingCapitalStructure: 'Working capital structure',
    investmentStructure: 'Investment structure',
    investmentBudget: 'Investment budget',
    investmentBudgetNotif: 'Fill in only if using non-refundable assets',
    materialInvestment: 'Material assets investment',
    nonMaterialInvestment: 'Non material assets investment',
    investmentSources: 'Investment sources',


    investorInfo: 'Investor/project owner information',
    companyName: 'Company name',
    companyResidence: 'Company residence',
    oib: 'OIB',
    personResponsible: 'Person responsible',
    contactName: 'Contact name',
    contactPhone: 'Contact phone',
    projectInfo: 'Project information',
    projectLocation: 'Project location',
    investmentType: 'Investment type',
    goal: 'Goal',
    timelinePlan: 'Timeline plan',
    madeBy: 'Made by',

    materialAssets: 'Material assets',
    nonMaterialAssets: 'Nonmaterial assets',
    workingCapital: 'Working capital',
    sumProjectInvestment: 'Sum project investment',

    foreignLongTermInvestment: 'Foreign longterm capital',
    creditAssets: 'Credit instruments',
    nonrefundableAssets: 'Irrevocable instruments',
    ownersCapital: 'Founders own capital',

    //LOAN
    loan: 'Loan',

    humanResources: 'Human resources',

    location: 'Location',
    locationAnalysis: 'Location analysis',
    environmentProtection: 'Human environment protection',
    environmentEffects: 'Project effect on environment',
    investmentRealization: 'Investment realization dynamics',
    workDynamics: 'Project feasibility analysis and work dynamics',
    marketingPlan: 'Marketing plan',
    marketingActivitiesPlan: 'Marketing activities plan and expenses budget',
    marketingReport: 'Marketing report',
    financialAnalysis: 'Financial analysis',
    basicInstrumentsEstimation: 'Predračunska vrijednost ulaganja u osnovna sredstva',
    basicInstrumentsStructure: 'Basic instruments structure',

    workingCapitalEstimation: 'Working capital estimated values',
    outsourceManufacturing: 'External manufacturing services',
    otherOutsourceServices: 'Other external services',
    merchProcurement: 'Merchandise procurement',
    otherNonmaterialExpenses: 'Other non-material expenses',

    businessField: 'Business field',
    currentAssets: 'Current assets',
    currentFinancialAnalysis: 'Current financial analysis',
    developmentProspect: 'Development prospect',

    moneyAmount: 'Amount',
    sum: 'Sum',
    passiveSum: 'Passive sum',
    sumAllYears: 'Sum for all years',
    for: 'for',
    showsValue: 'shows value',

    nonMaterialExpenses: 'Nonmaterial expenses',
    nonMaterialOtherExpenses: 'NonMaterial and other expenses',
    materialExpenses: 'Material expenses',
    materialExpense: 'Material expenses',
    rawMaterialExpenses: 'Raw material expenses',
    energyExpenses: 'Energy expenses',
    otherMaterialExpenses: 'Other material expenses',
    merchandiseSalesExpenses: 'Merchandise sales expenses',
    serviceExpenses: 'Service expenses',
    serviceExpense: 'Service expenses',
    transportServices: 'Trasnoport',
    maintenanceServices: 'Maintenance',
    registrationServices: 'Registration',
    leasingServices: 'Leasing',
    communalServices: 'Communal services',
    representationServices: 'Reprsentation services',
    otherNonMaterialExpenses: 'Other non-material expenses',
    travelExpenses: 'Travel expenses',
    compensationExpenses: 'Compensation',
    administrationExpenses: 'Administration',
    internalRepresentationExpenses: 'Internal representation expenses',
    insurancePremiums: 'Insurance premiums',
    bankingServices: 'Banking services',
    membershipExpenses: 'Membership expenses',
    independentTaxes: 'Independent taxes',
    rightToUseExpenses: 'Rights-to-use expenses',
    otherExpenses: 'Other expenses',
    addExpense: 'Add expense',
    expense: 'Expense',
    expenses: 'Expenses',
    unit: 'Measurement unit',
    costPerUnit: 'Cost per unit',

    productExpenses: {
      productionMaterial: 'Production material',
      productionSalary: 'Production salary',
      partnerServices: 'Partner services',
      amortization: 'Amortization',
      generalProductionCosts: 'General production costs',
      generalManagementCosts: 'General management costs',
      generalSalesCosts: 'General sales costs',
      generalDevelopmentCosts: 'General development costs',
    },

    addAmortizationItem: 'Add asset',

    expensesCalculation: 'Expenses budget and price calculations',
    incomeTax: 'Income tax',

    financeFlow: 'Finance flow',
    economyFlow: 'Economy flow',
    cashFlow: 'Cash flow',
    receipts: 'Receipts',
    fullIncomeWOSubsidies: 'Full income',
    pureNetIncomes: 'Pure net receipt',
    ownSources: 'Own sources',
    existingSourcesTransfer: 'Existing sources transfer',
    restOfProjectValue: 'Rest of the project value',
    longTermAssets: 'Long-term assets',
    fixedAssets: 'Long-term assets',
    fleetingAssets: 'Fleeting assets',
    outlays: 'Outlays',
    transferOfExistingAssets: 'Transfer of existing assets',
    investments: 'Investments',
    materialServicesCosts: 'Costs of materials and services',
    longTermAssetsInvestment: 'Long-term assets investment',
    otherShortTermInvestment: 'Other short-term investment',
    materialAndNonMaterialExpenses: 'Material and non-material expenses',
    staffExpenses: 'Staff expenses',
    staffExpense: 'Staff expenses',
    financialExpense: 'Financial expenses',
    specialExpenses: 'Special expenses',
    loanAnnuity: 'Loan annuity',
    loanPrincipal: 'Loan principal',
    netIncomes: 'Net incomes',
    costMaterial: 'Material cost',
    costNonMaterial: 'Non material cost',
    basicMeans: 'Basic means',
    salesProduct: 'Product sales',
    LicenseAndGoods: 'Goods and License',
    fundsOwn: 'Own funds',
    creditBICRO: 'Credit BICRO',
    fundsNoNRefundable: 'Non-refundable funds BICRO',
    cumulative: 'Cumulative',
    incomesFromOtherSubsidies: 'Income from other subsidies',
    loans: 'Loans',
    ebitda: 'EBITDA',


    //MARKET RATING
    marketRating: 'Market rating',
    staticEfficiencyRating: 'Investment project static efficiency rating',
    dynamicRating: 'Dynamic project rating',
    roiMethod: 'Return of investment method',
    netValueMethod: 'Net current value method',
    relativeValueMethod: 'Relative current value method',
    internalRentabilityMethod: 'Internal rentability rate method (IRR)',
    internalProfitabilityMethod: 'Internal profitability rate method',
    pureEconomicIncome: 'Economic flow net income',
    discountFactor: 'Discount factor',
    discount: 'Discount',
    projectYear: 'Project year',
    yearAmount: 'Yearly amount',
    nsv: 'NSV',
    currentProjectValueTwo: 'Current project value',
    profitabilityIndex: 'Profitability index',

    //INDICATORS
    indicators: 'Indicators',
    liquidityIndicators: 'Liquidity indicators',
    currentRatio: 'Current ratio',
    quickRatio: 'Quick ratio',
    financialCoefficient: 'Financial coefficient',
    debtFactor: 'Debt factor',
    financialAssetsOwnSourcesCover: 'Financial assets own sources cover',
    financialAssetsLongTermSourcesCover: 'Financial assets long-term sources cover',
    cashLiquidity: 'Current liquidity ratio',
    debtIndicators: 'Debt indicators',
    debtRatio: 'Debt ratio',
    equityRatio: 'Equity ratio',
    salesIncomeAssetTurnover: 'Sales income asset turnover',
    receivableTurnoverRatio: 'Receivable turnover ratio',
    sumIncomeAssetTurnover: 'Sum income asset turnover',
    netProfitMarginOnSalesRevenue: 'Net profit margin on sales revenue',
    netReturnOnAssets: 'Net return on assets',
    grossReturnOnAssets: 'Gross return on assets',
    returnOnEquity: 'Return on equity',
    operatingProfitability: 'Operating profitability',
    fleetingAssetsTurnover: 'Fleeting assets turnover',
    shortTermClaimsPaymentTime: 'Days of collection of receivables from customers',
    suppliersPaymentDays: 'Days of payment of obligations to suppliers',
    inventoryBindingDays: 'Inventory binding days',
    sumBusinessCostEffectiveness: 'Sum business cost effectiveness',
    regularBusinessCostEffectiveness: 'Regular business cost effectiveness',
    grossCirculationRentability: 'Gross circulation rentability',
    netCirculationRentability: 'Net circulation rentability',
    grossSumAssets: 'Gross sum assets',
    sumAssetsRentability: 'Sum assets rentability',
    ownCapitalRentability: 'Own capital rentabilty',
    ebitMargin: 'EBIT margin',
    ebitOperativeResult: 'EBIT operative result',
    ebitaMargin: 'EBITA margin',
    financialStabilityRatio: 'Financial stability ratio',
    additionalFinancialStabilityRatio: 'Additional financial stability ratio',
    activityIndicators: 'Activity indicators',
    assetTurnover: 'Asset turnover',
    profitabilityIndicators: 'Profitability indicators',
    profitabilityIndicatorsTwo: 'Profitability indicators',
    profitMargin: 'Profit margin',
    netProfitMargin: 'Net profit margin',
    returnOnSales: 'Return on sale',
    netAssetRentability: 'Net asset rentability',
    grossAssetRentability: 'Gross asset rentability',
    principalRentability: 'Principal rentability',
    chooseYears: 'Choose year',
    choose:'Choosen year',

    dynamicProjectRating: 'Dynamic project rating',
    returnOfInvestmentMethod: 'Metoda razdoblja povrata investicijskog ulaganja',
    investment: 'Investicija',
    accumulation: 'Akumulacija - neto primici',
    uncoveredAmount: 'Nepokriveni dio',
    yearly: 'Godišnje',
    cumulatively: 'Kumulativno',
    ROIBreakthrough: (amount: number, year: number) => `Razdoblje povrata uloženih sredstava u godinama: ${amount}`,

    sensitivityAnalysis: 'Project sensitivity',
    projectSensitivityAnalysis: 'Project sensitivity analysis',

    //Pokazatelji uspješnosti
    successIndicators: 'Success indicators',
    breakeven: 'Breakeven',

    //Zaključak
    conclusion: 'Conclusion',
    finalRating: 'Final project rating',

    no: 'no.',

    //PROJECT DEFINING
    riskAnalysis: 'Risk analysis',
    low: 'Low',
    intermediate: 'Intermediate',
    high: 'High',
    applicantImplementationCapacity: 'Applicant implementation capacity',
    techInvestmentElements: 'Technical investment elements',
    techProcess: 'Technology process description',
    techMaterialsAndEnergy: 'Goods, materials and energy expenses',
    techInvestmentStructure: 'Technical investment structure',
    buildingsCharacteristics: 'Project buildings characteristics / business facilities',
    techCapacity: 'Technological capacity and production volume',
    plannedProduction: 'Planned production capacity and structure',
    yearlyPlannedAmounts: 'Yearly planned amounts',
    yearlyPlannedIncome: 'Yearly planned income',
    productOrService: 'Product/service',
    amountAndPrices: 'Amounts and prices',
    price: 'Price',
    yearlyPlannedPrices: 'Yearly planned prices',
    businessIncomeFormation: 'Business income formation',
    productsSum: 'Products sum',
    servicesSum: 'Services sum',
    planedAmountCost: 'Planed amount and cost by year',
    planedCostPerYear: 'Planed cost by year',
    projectExperience: 'Applicant project experience',
    projectTeamEstablishment: 'Project team establishment methodology',
    applicantGeneral: 'Applicant general information',
    targetMarket: 'Target market',
    marketingMix: 'Shaping the marketing mix',
    marketingActivityPlan: 'Plan for the introduction of marketing activities\n',
    strength: 'Strengths',
    weakness: 'Weaknesses',
    opportunities: 'Opportunities',
    threats: 'Threats',
    problemAnalysis: 'Problem analysis',
    projectFormulation: 'Project proposal formulation',
    projectIndicators: 'Project indicators',
    projectSector: 'Project sector',
    techInvestment: 'Technical investment structure',
    risk: 'Risk',
    probability: 'Probability',
    influence: 'Influence',
    mitigateRisk: 'Measures to mitigate or avoid risk',
    internalRisks: 'Internal risks',
    externalRisks: 'External risks',

    materialProductionInputs: 'Material production inputs / Goods, materials, energy expenses',
    projectCommercialSustainability: 'Project commercial sustainability',

    graphs: 'Graphs',
    incomes: 'Incomes',
    incomesStructure: 'Income structure',
    expensesStructure: 'Expenses structure',
    incomesAndExpenses: 'Incomes and expenses',

    projection: 'Projection',
    confirm: 'Confirm',
    cancel: 'Cancel',

    //PROJECT REALIZATION
    planed: 'Planed',
    realized: 'Realized',
    customerIncome: 'Customer income',
    commissionsIncome: 'Commission income',
    insuranceIncome: 'Insurance income',
    taxReturnIncome: 'Tax return income',
    supplierExpense: 'Supplier expense',
    employeeExpense: 'Employee expense',
    insuranceExpense: 'Insurance expense',
    otherIncomeExpense: 'Other incomes/expenses',
    businessMoney: 'Business money',
    interestExpense: 'Interest expense',
    paidIncomeTax: 'Paid income tax',
    operatingActivityCashFlow: 'Net cash flows from operating activities',
    longTermAssetsIncome: 'Long-term assets income',
    financeIncome: 'Finance income',
    interestCashIncome: 'Interest cash income',
    dividendsIncome: 'Dividends income',
    loanSavingsIncome: 'Incomes on the basis of repayable loans and savings',
    investmentActivityIncome: 'Other investment activity incomes',
    investmentActivityIncomeTotal: 'Total investment activity income',
    investmentActivityCashFlow: 'Net cash flow from investment activity',
    longTermAssetsExpense: 'Long-term assets expense',
    financialExpenses: 'Financial expense',
    loanSavingsExpense: 'Expenses on the basis of repayable loans and savings',
    subsidiary: 'Acquisition of a subsidiary',
    investmentActivityExpense: 'Other investment activity expenses',
    investmentActivityExpenseTotal: 'Total investment activity Expense',
    coreCapitalIncome: 'Increase in core capital',
    financialEquityDebtIncome: 'Financial equity and debt income',
    loanPrincipalIncome: 'Loan principal income',
    financialActivityIncome: 'Other financial activities incomes',
    financialActivityIncomeTotal: 'Total financial activities income',
    loanPrincipalExpense: 'Loan principal expense',
    dividendsExpense: 'Dividend payment expense',
    financialLeasesExpense: 'Financial leases expense',
    coreCapitalExpense: 'Reduction in core capital',
    financialActivityExpense: 'Other financial activities expenses',
    financialActivityExpenseTotal: 'Total financial activities expense',
    financialActivityCashFlow: 'Net cash flow from financial activities',
    exchangeRateDifference: 'Unrealized exchange rate differences',
    cashFlowDifference: 'Net cash flow increase/decrease',
    startCoreCash: 'Money at the beginning of the period',
    endCoreCash: 'Money at the end of the period',
    wizard: {
      // 1. OPIS PODUZETNIKA/NOSITELJA PROJEKTA
      entrepreneurDescription: {
        // ----
        title: "1. OPIS PODUZETNIKA/NOSITELJA PROJEKTA",
        // ----
        step1:
          "Ovdje je potrebno <b>ukratko opisati poduzetnika ili nositelja</b>, npr. kada je osnovan, tko je osnivač i u kojoj je funkciji, postoje li ostali suosnivači/vlasnici i tko su, koja je osnovna djelatnost itd." +
          "<br><br>" +
          " Primjer pogledajte u idućem koraku.",
        // ----
        step2:
          "<h4>PRIMJER</h4> " +
          "<br><br>" +
          "<i>POLJOPRIVREDNA ZADRUGA ABC proizvodnja, trgovina i usluge (skraćeno PZ ABC) osnovana je 01. siječnja 2005. godine. Osnivač i upravitelj Zadruge je Ivan Ivanović, inače branitelj – umirovljenik, te Zadrugu zastupa neograničeno. Ovu funkciju obavlja volonterski bez naknade. </i>" +
          "<br><br> " +
          "<i>Zajedno s gospodinom Ivanom Ivanovićem, članovi/osnivači su: Ana Anić, Damir Damirović, Božo Božić i Ivana Ivanović. Osnovna djelatnost PZ BRANITELJ EKO je ekološka proizvodnja (stočarska i ratarska), za koju posjeduje svu potrebnu mehanizaciju. </i>"
      },
      // 1.1 INFORMACIJE O PODUZETNIKU / NOSITELJU PROJEKTA
      entrepreneurInfo: {
        // ----
        title: "1.1 INFORMACIJE O PODUZETNIKU / NOSITELJU PROJEKTA",
        // ----
        step1:
          "U ovoj sekciji <b>detaljnije razrađujemo i opisujemo nositelja</b>. " +
          "<br><br>" +
          "Podorobnije opisujemo dosadašnje značajnije aktivnosti i ulaganja. Vršimo opis djelatnosti, opisujemo lokacije na kojima posluje, imovinu, zemljišta koje posjeduje. " +
          "<br><br>" +
          "Također je potrebno ukratko opisati planirane aktivnosti te kako će se iste odraziti na nositelja projekta. " +
          "<br><br>" +
          " Primjer pogledajte u idućem koraku.",
        // ----
        step2:
          "<h4>PRIMJER</h4> " +
          "<br><br>" +
          "<i>POLJOPRIVREDNA ZADRUGA BRANITELJ EKO proizvodnja, trgovina i usluge (skraćeno PZ BRANITELJ EKO) osnovana je 28. svibnja 2005. godine. Osnivač i upravitelj Zadruge je Zlatko Kajmić, inače branitelj – umirovljenik, te Zadrugu zastupa neograničeno. Ovu funkciju obavlja volonterski bez naknade. Zajedno s gospodinom Zlatkom Kajmićem, članovi/osnivači su: Antun Buljan, Damir Gabud, Božo Križić, Branko Omazić i Mirče Tandara. Osnovna djelatnost PZ BRANITELJ EKO je ekološka proizvodnja (stočarska i ratarska), za koju posjeduje svu potrebnu mehanizaciju.  </i>" +
          "<br><br> " +
          "<i>Zadruga je 2006. godine, od Ministarstva obitelji, branitelja i međugeneracijske solidarnosti, primila jednokratnu potporu (mjera V) u iznosu od 150.000,00 kn koja je iskorištena za kupnju 2 ha zemljišta te je na njoj u 2008. godini ustanovljen nasad jabuka s otprilike 4100 stabala. Tijekom 2009. godine Zadruga se prijavila na natječaj za zakup poljoprivrednog zemljišta na području općine Levanjska Varoš, katastarska općina Majar, te je preuzeta zemlja u zakup na rok od jedne godine. Do 2011. godine odrađeni su svi potrebni koraci te je zemljište privedeno poljoprivrednoj namjeni, a potom i njezin jedan dio na natječaju i kupljen od države. Da bi se omogućio daljnji razvoj Zadruge i opstanak na tržištu, zaposleni su radnici te je obavljeno širenje na druge djelatnosti, a 2012. godine Zadruga je usklađena sa Zakonom o zadrugama. </i> " +
          "<br><br> " +
          "<i>U cilju proširenja svoje dosadašnje djelatnosti i konkuriranja na tržištu, Zadruga je 2015. godine dobila dozvolu za obavljanje dodatne djelatnosti sakupljanja i oporabe neopasnog otpada, na lokaciji Makarska ulica 17, 31400 Đakovo. Navedeni poslovni kompleks je u vlasništvu Republike Hrvatske, a kako bez tog poslovnog kompleksa Zadruga ne bi bila u stanju obavljati navedenu dodatnu djelatnost sakupljanja i oporabe neopasnog otpada, planira se kandidirati za kredit koji bi poslužio za kupnju nekretnina na navedenoj adresi. Ukupna površina nekretnina je 17.208 m2, a vrijednost iznosi 2.710.000,00 HRK. Procjena vrijednosti nekretnine provedena je 24. kolovoza 2020. godine. Kredit od Hrvatske banke za obnovu i razvitak (HBOR) očekuje se uz rok otplate od 14 godina (uključujući 3 godine počeka) te 3% kamatne stope.</i> " +
          "<br><br> " +
          "<i>Poslovanje Zadruge obavlja se na dvije lokacije. Prva je lokacija, ujedno i sjedište Zadruge, na adresi Donji Majar 21 – Majar, 31416 Levanjska Varoš, gdje se obavlja poljoprivredna proizvodnja ratarske kulture (kukuruz, ječam, suncokret, voćarstvo, stočarska proizvodnja – ekološki uzgoj crne slavonske svinje i uzgoj konzumnog šarana u umjetnim akumulacijama koje se koriste za navodnjavanje ostalih poljoprivrednih površina. Na navedenoj lokaciji nalazi se zemljište koje se obrađuje, kao i objekti za poljoprivrednu mehanizaciju, objekti za uzgoj ekološke crne slavonske svinje, ribnjak, trajni nasadi lješnjaka i nasadi jabuka. Dio poljoprivrednog zemljišta koje Zadruga obrađuje je u zakupu, a dio u vlasništvu Zadruge.</i> " +
          "<br><br> " +
          "<i>Druga lokacija Zadruge (poslovnica) je na adresi Makarska ulica 17, 31400 Đakovo. Radi se o nekretnini u vlasništvu Republike Hrvatske, a koju Poduzetnik/Investitor planira kupiti. Na navedenoj lokaciji obavlja se skupljanje i skladištenje neopasnog metalnog otpada. U 2019. godini Zadruga je na istoj lokaciji započela s poslovima gospodarenja građevinskim otpadom za koji posjeduje valjanu dozvolu. Riječ je o prikupljanju neopasnog građevinskog otpada (beton, cigle, crijep, pločice) te drobljenju betona s drobilicom od čega nastaje građevinski nasipni materijal koji se koristi u građevinarstvu za nasipavanje.</i> "

      },
      // 1.2 INFORMACIJE O PODUZETNIKU / NOSITELJU PROJEKTA
      entrepreneurBusinessSubject: {
        // ----
        title: "1.2 PREDMET POSLOVANJA PODUZETNIKA",
        // ----
        step1:
          "U ovoj sekciji <b>opisujemo glavne karakteristike poduzetničkog pothvata</b>. " +
          "<br><br>" +
          "Možemo opisati osnovnu djelatnost poduzetnika kao i ostale djelatnosti kojima se poduzetnik bavi slobodnim opisom kao i prema NKD-u, te predmete poslovanja odnosno djelatnosti koje su navedene u pripadajućem državnom registru. " +
          "<br><br>" +
          "Svakako je potrebno navesti i glavne proizvode poduzetnika" +
          "<br><br>" +
          " Primjer pogledajte u idućem koraku.",
        // ----
        step2:
          "<h4>PRIMJER</h4> " +
          "<br><br>" +
          "<i>Osnovna djelatnost Poljoprivredne zadruge Branitelj eko je voćarstvo (lijeska) – ekološka proizvodnja. Uz nju se proizvode i ratarske kulture ( kukuruz, ječam, žito, suncokret, itd.) i jabuke, uzgajaju se i crne slavonske svinje (ekološki uzgoj) te je ustanovljena i proizvodnja konzumnog šarana u umjetnim akumulacijama koje se koriste za navodnjavanje ostalih poljoprivrednih površina. Pored toga, Zadruga se bavi skupljanjem i skladištenjem neopasnog metalnog otpada, izradom PVC stolarije te građevinskim radovima (beskopno polaganje instalacija, usluge građevinske mehanizacije).</i>" +
          "<br><br> " +
          "<i>Osnovna djelatnost Zadruge, prema razvrstavanju prema NKD-u, je uzgoj jezgričavog i koštuničavog voća, potom prikupljanje sekundarnih sirovina, a bavi se još i građevinskom djelatnošću, izradom PVC stolarije, internom poljoprivrednom proizvodnjom te pružanjem usluga iz domene zadrugarstva. </i> " +
          "<br><br> " +
          "<p><i>Predmet poslovanja odnosno djelatnosti Zadruge su: sakupljanje šumskih gljiva, uzgoj voća, oraha i sličnog orašastog voća, usjeva za pripremanje napitaka i začina, uzgoj stoke, peradi i ostalih životinja, uzgoj usjeva i uzgoj stoke, peradi i ostalih životinja (mješovita proizvodnja), ostale uslužne djelatnosti u stočarstvu, osim veterinarskih usluga, lov, stupičarenje i briga o divljaci, uključujući usluge povezane s njima, usluge povezane sa šumarstvom i sječom drva, ribarstvo, uzgoj riba i usluge povezane s njima, proizvodnja hrane i pića, štavljenje i obrada kože; proizvodnja kovčega i torbi, ručnih torbica, sedlarskih i remenarskih proizvoda i obuće, prerada drva, proizvodnja proizvoda od drva i pluta, osim namještaja; proizvodnja predmeta od slame i pletarskih proizvoda, proizvodnja celuloze, papira i proizvoda od papira, proizvodnja proizvoda od gume i plastike, proizvodnja ostalih nemetalnih mineralnih proizvoda, proizvodnja metala, proizvodnja proizvoda od metala, osim strojeva i opreme, proizvodnja namještaja, proizvodnja strojeva za proizvodnju i korištenje mehaničke energije, osim motora za zrakoplove i motorna vozila, proizvodnja ostalih strojeva za opće namjene, proizvodnja strojeva za poljoprivredu i šumarstvo, proizvodnja alatnih strojeva, proizvodnja ostalih strojeva za posebne namjene, proizvodnja aparata za kućanstvo, proizvodnja motornih vozila, prikolica i poluprikolica, proizvodnja igara i igračaka, proizvodnja metli i četaka, reciklaža, održavanje i popravak motornih vozila, pripremanje hrane i pružanje usluga prehrane, pripremanje i usluživanje pića i napitaka i pružanje usluga smještaja, pripremanje hrane za potrošnju na drugom mjestu (u prijevoznim sredstvima, na priredbama i sl.) i opskrba tom hranom (catering), cestovni prijevoz robe, skladištenje robe, djelatnosti ostalih agencija u prijevozu, poslovanje nekretninama, iznajmljivanje strojeva i opreme, bez rukovatelja i predmeta za osobnu uporabu i kućanstvo, djelatnosti pakiranja, uzgoj zrnatih žitarica, krumpira, šećerne repe, duhana, uljarica, krmnog bilja, hmelja, pamuka, graška, graha, ljekovitog bilja, povrća, začinskih trava, gljiva i cvijeća, kupnja i prodaja robe, osim oružja i streljiva, lijekova i otrova, trgovačko posredovanje na domaćem i inozemnom tržištu, građenje, projektiranje i nadzor, savjetovanje u vezi s građenjem, projektiranjem i nadzorom, međunarodni transport robe i putnika u cestovnom prometu, izvođenje investicijskih radova u inozemstvu, zastupanje inozemnih tvrtki, međunarodno otpremništvo, izgradnja, ugradnja, popravak i održavanje željezne stolarije, izgradnja, ugradnja, popravak i održavanje aluminijske stolarije, izgradnja, ugradnja, popravak i održavanje plastične stolarije, izgradnja, ugradnja, popravak i održavanje drvene stolarije, stručni poslovi zaštite okoliša, poslovi praćenja kakvoće zraka i emisije zraka, djelatnost održavanja i/ili popravak te isključivanja iz uporabe proizvoda koji sadrže tvari koje oštećuju ozonski sloj, stručni poslovi zaštite od buke, skupljanje otpada za potrebe drugih, prijevoz otpada za potrebe drugih, posredovanja u organiziranju oporabe i/ili zbrinjavanju otpada u ime drugih, sakupljanje, oporabe i/ili zbrinjavanja (obrada, odlaganje, spaljivanje i drugi načini zbrinjavanja otpada), odnosno djelatnost gospodarenja posebnim kategorijama otpada, uvoz otpada, izvoz otpada, proizvodnja električne energije, prijenos električne energije, distribucija električne energije, opskrba električnom energijom, organiziranje tržišta električnom energijom, proizvodnja plina, isporuka i prodaja prirodnog plina iz vlastite proizvodnje, dobava plina, skladištenje prirodnog plina, transport prirodnog plina, distribucija plina, pokusno bušenje i sondiranje terena za građenje, stručni poslovi zaštite od buke, ugradnja solarnih kolektora, spremnika, ugradnja fotonaponskih solarnih modula, proizvodnja solarnih kolektora, spremnika, toplovodnih bojlera te sličnih kotlova, proizvodnja piljene građe, impregnacija drva, proizvodnja građevinske stolarije i elemenata.</i></p> " +
          "<br><br> " +
          "<i>Osnovni proizvodi Zadruge su jabuke, lješnjaci, crne slavonske svinje, šarani (ratarska djelatnost za potrebe hranidbe crnih slavonskih svinja i šarana - interna proizvodnja), sakupljanje otpada, građevinska stolarija i pružanje usluga u građevinskoj djelatnosti. Unutar poslovnog kompleksa i pripadajućeg zemljišta u Đakovu, Zadruga obavlja djelatnosti sakupljanja i oporabe neopasnog otpada.</i> "

      },
      // 1.3 INFORMACIJE O PODUZETNIKU / NOSITELJU PROJEKTA
      entrepreneurCurrentAssets: {
        // ----
        title: "1.3 POSTOJEĆA IMOVINA PODUZETNIKA",
        // ----
        step1:
          "U ovoj sekciji <b>specificiramo postojeću imovinu s kojom se ulazi u projekt.</b>. " +
          "<br><br>" +
          "Podorobnije opisujemo dosadašnje značajnije aktivnosti i ulaganja. Vršimo opis djelatnosti, opisujemo lokacije na kojima posluje, imovinu, zemljišta koje posjeduje. " +
          "<br><br>" +
          "Također je potrebno ukratko opisati planirane aktivnosti te kako će se iste odraziti na nositelja projekta. " +
          "<br><br>" +
          " Primjer pogledajte u idućem koraku.",
        // ----
        step2:
          "<h4>PRIMJER</h4> " +
          "<br><br>" +
          "<i>POLJOPRIVREDNA ZADRUGA BRANITELJ EKO proizvodnja, trgovina i usluge (skraćeno PZ BRANITELJ EKO) osnovana je 28. svibnja 2005. godine. Osnivač i upravitelj Zadruge je Zlatko Kajmić, inače branitelj – umirovljenik, te Zadrugu zastupa neograničeno. Ovu funkciju obavlja volonterski bez naknade. Zajedno s gospodinom Zlatkom Kajmićem, članovi/osnivači su: Antun Buljan, Damir Gabud, Božo Križić, Branko Omazić i Mirče Tandara. Osnovna djelatnost PZ BRANITELJ EKO je ekološka proizvodnja (stočarska i ratarska), za koju posjeduje svu potrebnu mehanizaciju.  </i>" +
          "<br><br> " +
          "<i>Zadruga je 2006. godine, od Ministarstva obitelji, branitelja i međugeneracijske solidarnosti, primila jednokratnu potporu (mjera V) u iznosu od 150.000,00 kn koja je iskorištena za kupnju 2 ha zemljišta te je na njoj u 2008. godini ustanovljen nasad jabuka s otprilike 4100 stabala. Tijekom 2009. godine Zadruga se prijavila na natječaj za zakup poljoprivrednog zemljišta na području općine Levanjska Varoš, katastarska općina Majar, te je preuzeta zemlja u zakup na rok od jedne godine. Do 2011. godine odrađeni su svi potrebni koraci te je zemljište privedeno poljoprivrednoj namjeni, a potom i njezin jedan dio na natječaju i kupljen od države. Da bi se omogućio daljnji razvoj Zadruge i opstanak na tržištu, zaposleni su radnici te je obavljeno širenje na druge djelatnosti, a 2012. godine Zadruga je usklađena sa Zakonom o zadrugama. </i> " +
          "<br><br> " +
          "<i>U cilju proširenja svoje dosadašnje djelatnosti i konkuriranja na tržištu, Zadruga je 2015. godine dobila dozvolu za obavljanje dodatne djelatnosti sakupljanja i oporabe neopasnog otpada, na lokaciji Makarska ulica 17, 31400 Đakovo. Navedeni poslovni kompleks je u vlasništvu Republike Hrvatske, a kako bez tog poslovnog kompleksa Zadruga ne bi bila u stanju obavljati navedenu dodatnu djelatnost sakupljanja i oporabe neopasnog otpada, planira se kandidirati za kredit koji bi poslužio za kupnju nekretnina na navedenoj adresi. Ukupna površina nekretnina je 17.208 m2, a vrijednost iznosi 2.710.000,00 HRK. Procjena vrijednosti nekretnine provedena je 24. kolovoza 2020. godine. Kredit od Hrvatske banke za obnovu i razvitak (HBOR) očekuje se uz rok otplate od 14 godina (uključujući 3 godine počeka) te 3% kamatne stope.</i> " +
          "<br><br> " +
          "<i>Poslovanje Zadruge obavlja se na dvije lokacije. Prva je lokacija, ujedno i sjedište Zadruge, na adresi Donji Majar 21 – Majar, 31416 Levanjska Varoš, gdje se obavlja poljoprivredna proizvodnja ratarske kulture (kukuruz, ječam, suncokret, voćarstvo, stočarska proizvodnja – ekološki uzgoj crne slavonske svinje i uzgoj konzumnog šarana u umjetnim akumulacijama koje se koriste za navodnjavanje ostalih poljoprivrednih površina. Na navedenoj lokaciji nalazi se zemljište koje se obrađuje, kao i objekti za poljoprivrednu mehanizaciju, objekti za uzgoj ekološke crne slavonske svinje, ribnjak, trajni nasadi lješnjaka i nasadi jabuka. Dio poljoprivrednog zemljišta koje Zadruga obrađuje je u zakupu, a dio u vlasništvu Zadruge.</i> " +
          "<br><br> " +
          "<i>Druga lokacija Zadruge (poslovnica) je na adresi Makarska ulica 17, 31400 Đakovo. Radi se o nekretnini u vlasništvu Republike Hrvatske, a koju Poduzetnik/Investitor planira kupiti. Na navedenoj lokaciji obavlja se skupljanje i skladištenje neopasnog metalnog otpada. U 2019. godini Zadruga je na istoj lokaciji započela s poslovima gospodarenja građevinskim otpadom za koji posjeduje valjanu dozvolu. Riječ je o prikupljanju neopasnog građevinskog otpada (beton, cigle, crijep, pločice) te drobljenju betona s drobilicom od čega nastaje građevinski nasipni materijal koji se koristi u građevinarstvu za nasipavanje.</i> "

      },
      // 1.4 FINANCIJSKA ANALIZA DOSADAŠNJEG POSLOVANJA
      recentFinancialAnalysisSteps: {
        // ----
        title: "1.4 FINANCIJSKA ANALIZA DOSADAŠNJEG POSLOVANJA",
        // ----
        step1:
          "U ovoj sekciji <b>opisno unosimo financijsku analizu prijavitelja i potkrepljujemo je pokazateljima efikasnosti projekta koji se računaju iz pozicija RDG i bilance.</b>. " +
          "<br><br>" +
          "Za svaku od navedenih sekcija ćemo opisati kako ju ispuniti a zatim dati i primjer." +
          "<br><br>" +
          "Započnimo za opisnim dijelom analize u idućem koraku.",
        // ----
        step2:
          "<h4>OPISNI DIO FINANCIJSKE ANALIZE</h4> " +
          "<br><br>" +
          "Opisujemo na temelju kojih financijskih izvešća je provedena analiza i za koje godine su unešena izvješća. Navesti zadnje stanje aktive/pasive i prikazati kretanje u odnosu na stanje u prethodnim izvještajima. Prokomentirati strukturu imovine - dugotrajne i kratkotrajne." +
          "<br><br> " +
          "Navedite stanje poslovnih prihoda te navedite kakvo je njihovo kretanje u odnosu na prethodna izvješća, te objasnite što je uzrokovalo ta kretanja, te zaključite sa ocjenom poduzetnika. " +
          "<br><br> " +
          "Prije nego što pređemo na račun dobiti i gubitka pogledajte primjer opisnog dijela u idućem koraku.",
        step3:
          "<h4>PRIMJER</h4> " +
          "<br><br>" +
          "<i>Financijska analiza Prijavitelja provedena je na temelju financijskih izvješća (bilance, računa dobiti i gubitka) za 2018. i 2019. godinu. Financijski položaj Prijavitelja prikazan je kroz bilancu stanja za 2018. i 2019. godinu sa strukturom imovine i obveza te dinamikom i tendencijom promjena pojedinih bilančnih pozicija.</i>" +
          "<br><br> " +
          "<i>Aktiva/pasiva Prijavitelja, prema prethodnom pregledu ukupne imovine Investitora na dan 31.12.2019. godine, iskazana je u iznosu od 2.829.616 HRK, što je za 580.715,00 HRK odnosno za 17,03% manje u odnosu na aktivu iskazanu na dan 31.12.2018. godine, kada je iznosila 3.410.331 HRK. Najveći udio u aktivi zauzima dugotrajna imovina i to 91,59%. U strukturi dugotrajne imovine najveći udio zauzima materijalna imovina, točnije, postrojenja i oprema, dok ostatak vrijednosti materijalne imovine zauzimaju zemljište, građevinski objekti, biološka imovina i ostala materijalna imovina.</i> " +
          "<br><br> " +
          "<i>Kratkotrajna imovina zauzima udio od 8,41% ukupne aktive. U strukturi kratkotrajne imovine najveći udio zauzimaju zalihe i to prvenstveno sirovine i materijal te proizvodnja u tijeku. Osim zaliha, kratkotrajna imovina sastoji se i od potraživanja i to od potraživanja od kupaca te od države i drugih institucija.</i>" +
          "<br><br> " +
          "<i>Poslovni prihodi Investitora u 2019. godini iznose 2.961.440,00 HRK, što je u odnosu na 2018. godinu povećanje od 714.817,00 HRK odnosno 31,82%. Sukladno povećanju poslovnih prihoda povećali su se poslovni rashodi za 619.351,00 HRK odnosno 29,11%.</i>" +
          "<br><br> " +
          "<i>Povećanje rashoda uvjetovano je povećanjem materijalnih troškova, točnije, troškova sirovina i materijala, troškova prodane robe te neznatnog povećanja ostalih vanjskih troškova. Rashodi su povećani i posljedičnim povećanjem troškova osoblja. Vidljivo je kako su se i troškovi amortizacije i ostali troškovi povećali.</i> " +
          "<br><br> " +
          "<i>Povećanje prihoda uvjetovano je povećanjem prihoda od prodaje za 829.638,00 HRK odnosno za 46,92%. Pored toga, ostali poslovni prihodi smanjili su se za 114.821,00 HRK u odnosu na 2018. godinu, odnosno za 24%. Financijski prihodi u 2019. godini iznose 21,00 HRK te se odnose na ostale prihode s osnove kamata. Financijski rashodi doživjeli su povećanje za skoro 400% te u 2019. godini iznose 122.825,00 HRK uslijed povećanja rashoda s osnova kamata i sličnih rashoda.</i>"
          +
          "<br><br> " +
          "<i>U ukupnosti, Investitor je u 2019. godini ostvario dobit u iznosu od 80.370,00 HRK što je 3,14% manje ostvarene dobiti u odnosu na prethodnu 2018. godinu. Obzirom da je odstupanje vrlo malo, podaci egzaktno pokazuju da se radi o perspektivnom društvu.</i>"
      },
    },

  },
  'hrv': {
    insufficientData: 'Nedovoljno podataka',
    newStudyWarning: 'Stavke se ne mogu mijenjati nakon kreiranja studije',
    recentYears: 'Posljednje dvije godine',
    year2018: '2018',
    year2021: '2021',
    formerYears: 'Pretposljednje dvije godine',
    showOldYears: 'Prikaži prošle godine',
    showMonthlyCashFlow: 'Prikaži razradu na mjesečnoj bazi',
    import: 'Uvezi',
    balanceImport: 'Uvezi bilancu',
    profitAndLossImport: 'Uvezi račun dobiti i gubitka',
    clearImport: 'Ukloni podatke',
    source: 'Izvor',
    generateWithAi: "Generiraj sa AI-em",
    generating: "Generiram...",
    sourceOfFunding: 'Izvor financiranja',
    systemSettings: 'Postavke sistema',
    initialInvestmentFalse: 'Suma početnih ulaganja mora biti jednaka sumi izvora financiranja!',
    initialInvestmentTrue: 'Suma početnih ulaganja je jednaka sumi izvora financiranja',

    investmentStudy: 'Investicijska studija',
    newInvestmentStudy: 'Nova investicijska studija',
    addInvestmentStudy: 'Dodaj investicijsku studiju',
    projectDefining: 'Definiranje projekta',
    newProjectDefining: 'Novo definiranje projekta',
    addProjectDefining: 'Dodaj definiranje projekta',
    financeAnalysis: 'Financijska analiza',
    newFinanceAnalysis: 'Nova financijska analiza',
    addFinanceAnalysis: 'Dodaj financijsku analizu',
    shortBalance: 'Skračena bilanca i RDG',
    newShortBalance: 'Nova skračena bilanca i RDG',
    addShortBalance: 'Dodaj krati RDG i bilancu',
    loanTools: 'Obračun kredita',
    newLoan: 'Novi obračun kredita',
    addLoan: 'Dodaj obračun kredita',
    projectRealization: 'Praćenje ralizacije projetka',
    newProjectRealization: 'Novo praćenje realizacije projekta',
    addProjectRealization: 'Dodaj praćenje realizacije projekta',
    name: 'Naziv studije',
    year: 'Godina',
    years: 'Godine',
    yearsAmount: 'Broj poslovnih godina',
    startYear: 'Kalendarska godina prve poslovne godine',
    investmentStudyCreated: 'Investicijska studija je stvorena',
    projectDefininfCreated: 'Definiranje projekta je stvoreno',
    studyDeleted: 'Studija obrisana',
    studiesList: 'Lista studija',
    financeList: 'Lista financijskih analiza',
    balanceList: 'Lista kratke bilance i RDG-a',
    loanList: 'Lista obračuna kredita',
    realizationList: 'Lista realizacije projekta',
    type: 'Tip',
    studyType: 'Tip',
    createdAt: 'Vrijeme stvaranja',
    contentUpdatedAt: 'Zadnja izmjena',
    intro: 'Uvod',
    welcomeIntro: 'Dobrodošli u investicijsku studiju',
    introDescription: 'Investicijska studija je e-alat za potporu poduzetnicima, voditeljima projekata, poduzetnicima i ostalima',
    reviewInvestmentStudy: 'Pregledajte investicijske studije',
    defineNewProjects: 'Definirajte nove projekte',
    defineNewProjectsL: 'DEFINIRAJTE NOVE PROJEKTE ',
    addNewStudy: 'Dodajte novu studiju',
    reviewEarlierProjects: 'Pregledajte ranije projekte',
    review: 'PREGLEDAJ',
    addNewStudyL: 'DODAJTE NOVU STUDIJU',
    startTheGuide: 'Pokrenite interaktivni vodič',
    startGuide: 'POKRENITE VODIČ',
    summary: 'Sažetak projekta',
    confirmDirtyForm: 'Imate promjene koje nisu spremljene, jeste li sigurni da želite dalje?',
    currency: 'Valuta',
    kn: 'HRK',
    eur: 'EUR',
    eng: 'Engleski',
    cro: 'Hrvatski',
    tableName: 'Naziv',
    tableYears: 'Godine (Iznosi u',
    rate: 'Stopa',
    purchaseValue: 'Nabavna vrijednost',
    startingMonth: 'Početni mjesec',
    startingYear: 'Početna godina',
    residue: 'Ostatak',
    exportTable: 'Izvezi Tablicu',
    netBookValue: 'Neto knjigovodstvena vrijednost',
    share: 'Udio',
    amount: 'Količina',
    amountsTo: 'Iznosi',
    remarkMarketingReportOne: '*Napomena: Planirane troškove marketinških aktivnosti obavezno uključiti u tablici 9.7. Proračun troškova i kalkulacija cijena pod stavkom „Troškovi usluga“ koji je ponuđen u padajućem izborniku pod stavkom „Marketinške aktivnosti“.',
    remarkMarketingReportTwo: '*Napomena: Marketinški izvještaj predstavlja mjesečnu razradu troškova marketinških aktivnosti za prvu godinu navedenu u Planu marketinških aktivnosti i proračuna troškova.',


    //Opis poduzetnika / nositelja projekta
    // studyWizard: {
    //   entrepreneurDescription: {
    //     stepOne: "Na ovoj sekciji potrebno je ukratko opisati nositelja projekta u nekoliko rečenica npr. kada je subjekt osnovan, tko su osnivači i povezane osobe, u kojoj su funkciji, koja je osnovna djelatnost itd. \n \n Na idućem koraku pogledajte primjer opisa.",
    //     stepTwo: "POLJOPRIVREDNA ZADRUGA BRANITELJ EKO proizvodnja, trgovina i usluge (skraćeno PZ BRANITELJ EKO) osnovana je 28. svibnja 2005. godine. Osnivač i upravitelj Zadruge je Zlatko Kajmić, inače branitelj – umirovljenik, te Zadrugu zastupa neograničeno. Ovu funkciju obavlja volonterski bez naknade. Zajedno s gospodinom Zlatkom Kajmićem, članovi/osnivači su: Antun Buljan, Damir Gabud, Božo Križić, Branko Omazić i Mirče Tandara. Osnovna djelatnost PZ BRANITELJ EKO je ekološka proizvodnja (stočarska i ratarska), za koju posjeduje svu potrebnu mehanizaciju. "
    //   }
    // },
    entrepreneurDescription: 'Opis poduzetnika / nositelja projekta',
    entrepreneurInfo: 'Informacije o poduzetniku / nositelju projekta',
    entrepreneurBusinessSubject: 'Predmet poslovanja poduzetnika',
    entrepreneurCurrentAssets: 'Postojeća imovina poduzetnika',
    recentBusinessFinancialAnalysis: 'Financijska analiza dosadašnjeg poslovanja',
    potentialDevelopmentRating: 'Ocjena razvojnih mogućnosti ulagatelja',

    info: 'Info',
    projectDescription: 'Opis projekta',
    initialInvestment: 'Početna ulaganja',
    employees: 'Zaposlenici',
    qualificationsStructure: 'Struktura zaposlenika',
    level_1: 'Eko razina 1',
    level_2: 'Eko razina 2',
    level_3: 'Eko razina 3',
    level_4: 'Eko razina 4',
    level_5: 'Eko razina 5',
    level_6: 'Eko razina 6',
    level_7: 'Eko razina 7',
    level_8: 'Eko razina 8',
    addSector: 'Dodaj sektor',
    products: 'Proizvodi',
    services: 'Usluge',
    newProduct: 'Novi proizvod',
    addProduct: 'Dodaj proizvod',
    product: 'Proizvod',
    service: 'Usluga',
    marketingActivity: 'Marketinške aktivnosti',

    //Market analysis
    marketAnalysis: 'Analiza tržišta',
    procurementMarket: 'Tržište nabave',
    salesMarket: 'Tržište prodaje',
    marketAnalysisSummary: 'Sažetak analize tržišta i procjena ostvarenja prihoda',

    employeesDynamicAndStructure: 'Dinamika i struktura zaposlenih',
    wantedStaffAnalysis: 'Analiza potrebnih kadrova',
    employeesStructure: 'Struktura zaposlenih radnika',
    humanResourcesReport: 'Izvještaj ljudskih resursa',
    yearSalaryBudget: 'Proračun godišnjih bruto plaća',
    employeesCount: 'Broj zaposlenika',
    sumStaffExpenses: 'Ukupni troškovi osoblja',
    averageMonthlySalary: 'Prosječna mjesečna plaća Bruto II',
    totalEmployees: 'Ukupan broj zaposlenika',
    employeesNumber: 'Broj zaposlenika',
    grossSalary: 'Plaća bruto 2',
    numberOfPeople: 'Mjera za broj osoba',
    numberFullTime: 'Mjera za puno radno vrijeme',
    initialState: 'Početno stanje',
    initialStateDesc: 'unijeti broj zaposlenih na datum 01.01.',
    employed: 'Zaposleno',
    employedDesc: 'unijeti planirani broj novozaposlenih tijekom razdoblja 01.01-31.12',
    staffLeft: 'Otišlo',
    staffLeftDesc: 'unijeti planirani broj zaposlenih koji će napustiti tvrtku tijekom razdoblja 01.01-31.12',
    description: 'Opis',
    sectorName: 'Naziv sektora',
    descriptionDesc: 'odnosi se na Odjel / Stručna sprema / Zanimanje / Naziv radnog mjesta, ili slično',
    finalState: 'Završno stanje',
    explanation: 'Objašnjenje',
    EKO : 'Europski kvalifikacijski okvir - EKO (engl. EQF – European Qualifications Framework) kao glavni temelj cjeloživotnog obrazovanja je inicijativa Europske unije koja služi za raspoznavanje nacionalnih kvalifikacija u svim europskim zemljama koje se stječu kroz sve oblike obrazovanja od osnovnog obrazovanja do visoke naobrazbe. EKO opisuje kvalifikacije koje se stječu kada učenik završi određenu razinu obrazovanja. One su definirane preko ishoda učenja koji opisuju što učenik zna, razumije i može učiniti na kraju procesa učenja.',
    //9. Ekonomsko-financijska analiza
    economicFinancialAnalysis: 'Ekonomsko financijska analiza',
    basicInstrumentsInvestment: 'Struktura ulaganja u osnovna i obrtna sredstva',
    //Predračunska vrijednost ulaganja u dugotrajnu imovinu
    fixedAssetsEstimateInvestment: 'Predračunska vrijednost ulaganja u dugotrajnu imovinu',
    nonMaterialEstimateInvestment: 'Predračunska vrijednost ulaganja u nematerijalnu imovinu',
    materialEstimateInvestment: 'Predračunska vrijednost ulaganja u materijalnu imovinu',
    //Predračunska vrijednost ulaganja u kratkotrajnu imovinu
    currentAssetsEstimateInvestment: 'Predračunska vrijednost ulaganja u kratkotrajnu imovinu',
    workingCapitalEstimateInvestment: 'Predračunska vrijednost potrebne kratkotrajne imovine i obrtnih sredstava',
    //Ukupna predračunska vrijednost ulaganja
    sumEstimateInvestment: 'Ukupna predračunska vrijednost ulaganja',
    fixedAndCurrentAssetsInvestment: 'Struktura ulaganja u dugotrajnu i kratkotrajnu imovinu',
    yearInvestmentBudget : 'Proračun troškova ulaganja po godinama',
    nonMaterialInstruments: 'Nematerijalna sredstva',
    materialInstruments: 'Materijalna sredstva',
    workingCapitalInstruments: 'Obrtna sredstva',
    sourceOfGrants: 'Izvor bespovratnih sredstava',
    shareOfGrants: 'Udio bespovratnih sredstava',
    totalProjectCosts: 'Ukupni troškovi projekta',
    //Izvori financiranja i kreditni uvjeti
    financeSourcesAndCredit: 'Izvori financiranja',
    financeSources: 'Izvori financiranja',
    yearFinanceSources: 'Izvori financiranja po godinama',
    inputs: 'Unosi',
    requestedLoanAmount: 'Iznos kredita',
    interestRate: 'Kamatna stopa',
    repaymentYears: 'Broj godina otplate',
    defermentYears: 'Broj godina počeka',
    numberOfYears: 'broj godina',
    quarter: 'Kvartal',
    loanAmount: 'Iznos duga',
    repayment: 'Otplata',
    yearlyInterest: 'Godišnje kamate',
    yearlyAnnuity: 'Godišnji anuiteti',
    //Obračun kreditnih obveza
    creditCalculation: 'Kreditni uvjeti i obračun kredita',
    creditRepaymentPlan: 'Plan otplate kredita',
    //Proračun amortizacije
    amortizationBudget: 'Proračun amortizacije',
    amortization: 'Amortizacija',
    amortizationLongtermAssets: 'Dugotrajna imovina iz projekta',
    pastAssetsOutProject: 'Imovina iz prethodnog razdoblja koja nije nabavljena putem projekta',
    futureAssetsOutProject: 'Imovina iz budućeg razdoblja koja nije nabavljena putem projekta',
    //Proračun troškova i amortizacija cijena
    expensesBudgetAndPrices: 'Proračun troškova i kalkulacija cijena',
    sumProductionExpenses: 'Kalkulacija ukupnih troškova proizvodnje',
    planedAmount: 'Planirane količine po godinama',
    planedCostPerUnit: 'Planirani trošak po jedinici po godinama',
    planedSumAmount: 'Planirani ukupni trošak po godinama',
    //Formiranje ukupnih prihoda
    totalIncome: 'Formiranje ukupnih prihoda',
    fullIncome: 'Formiranje ukupnih prihoda',
    fullIncomeCalculation: 'Kalkulacija ukupnih prihoda',
    //Formiranje ukupnih rashoda
    totalExpense: 'Formiranje ukupnih rashoda',
    fullExpense: 'Formiranje ukupnih rashoda',
    totalExpenseCalculation: 'Kalkulacija ukupnih rashoda',
    //Projekcija računa dobiti i gubitka
    profitAndLossProjection: 'Projekcija računa dobiti i gubitka',
    profitAndLoss: 'Račun dobiti i gubitka',
    expenseIncomeType: 'Vrsta rashoda/prihoda',
    businessIncome: 'Poslovni prihodi',
    salesIncome: 'Prihodi od prodaje',
    otherBusinessIncome: 'Ostali poslovni prihodi',
    otherIncome: 'Ostali prihodi',
    otherExpense: 'Ostali troškovi',
    otherBusinessExpense: 'Ostali poslovni rashodi',
    grantRevenues: 'Prihodi od potpora',
    financialIncome: 'Financijski prihodi',
    profitShare: 'Udio u dobiti od pridruženih poduzetnika',
    otherProfits: 'Izvanredni - ostali prihodi',
    lossShare: 'Udio u gubitku od pridruženih poduzetnika',
    otherLosses: 'Izvanredni - ostali rashodi',
    businessExpense: 'Poslovni rashodi',
    stockDifference: 'Promjene vrijednosti zaliha proizvodnje u tijeku i gotovih proizvoda',
    valueBalancing: 'Vrijednosno usklađivanje',
    profit: 'Dobit ili gubitak prije oporezivanja',
    profitAfterTax: 'Dobit ili gubitak razdoblja',
    profitOrLossBeforeTax: 'Dobit/gubitak prije oporezivanja',
    profitOrLossAfterTax: 'Dobit/gubitak nakon oporezivanja',
    lossBeforeTax: 'Gubitak prije oporezivanja',
    lossAfterTax: 'Gubitak nakon oporezivanja',
    netProfitLossPeriod: 'Neto dobit gubitak razdoblja',
    profitPeriod: 'Dobit razdoblja',
    lossPeriod: 'Gubitak razdoblja',
    businessProfitLoss: 'Poslovna dobit/gubitak',

    expenseType: 'Vrsta rashoda',
    loanInterests: 'Kamate na kredite',
    negativeExchangeRates: 'Negativne tečajne razlike',
    otherFinancialExpenses: 'Ostali financijski rashodi',
    incomeType: 'Vrsta prihoda',
    productRevenue: 'Prihodi od proizvoda',
    servicesRevenue: 'Prihodi od usluga',
    salesGoodsRevenue: 'Prihodi od prodaje gotove robe',
    interestIncome: 'Prihodi od kamata',
    foreignExchangeIncome: 'Prihodi od tečajnih razlika',
    incomeSecurities: 'Prihodi od vrijednosnica',
    otherFinancialIncome: 'Ostali financijski prihodi',

    //Projekcija potrebnih obrtnih sredstava
    currentAssetsProjection: 'Projekcija potrebnih obrtnih sredstava',
    items: 'Stavke',
    daysOutstanding: 'Dani vezivanja',
    turnover: "Koeficijent obrtaja",
    productStocks: 'Zalihe proizvoda',
    productStocksGoods: '(robe)',
    stocks: 'Zalihe',
    rawMaterials: 'Sirovine i materijali',
    tradeReceivables: 'Potraživanja od kupaca',
    money: 'Novac',
    otherBusinessExpenses: 'Ostali troškovi poslovanja',
    pretax: 'PDV - pretporez',
    taxDays: 'PDV - u izdanim računima',
    sourcesOfBusiness: 'Izvori za tekuće poslovanje',
    suppliers: 'Dobavljači',
    suppliersOverdue: 'Dobavljači - nedospjelo',
    laborCost: 'Troškovi rada',
    laborCostSalaries: 'Trošak rada - plaće',
    interest: 'Kamata',
    tax: 'Porez',
    difference: 'Razlika (1-2)',
    workingCapitalInvestment: 'Ulaganja u obrtna sredstva',
    availableWorkingCapital: 'Raspoloživa obrtna sredstva',
    //Projekcija novčanog toka

    financialFlow: 'Financijski tijek',
    finance: "Financijski tijek",
    economicFlow: 'Ekonomski tijek',
    economic: "Ekonomski tijek",
    //Balance projection
    balanceProjection: 'Projekcija bilance',
    importBalanceRDG: 'Unesite bilancu i račun dobiti i gubitka da dobijete statičku ocjenu efikasnosti',
    balance: 'Bilanca',
    unpaidCapitalClaims: 'Potraživanja za upisani a neuplaćeni kapital',
    claims: 'Dugotrajna potraživanja',
    claimsDays: 'Dugotrajna potraživanja',
    shortTermClaims: 'Kratkotrajna potraživanja',
    delayedTaxAssets: 'Odgođena porezna imovina',
    financialAssets: 'Financijska imovina',
    shortTermFinancialAssets: 'Financijska imovina',
    longTermFinancialAssets: 'Financijska imovina',
    futurePaidExpenses: 'Plaćeni troškovi budućeg poslovanja i obračunati prihodi',
    capitalReserves: 'Kapitalne rezerve',
    capitalAndReserves: 'Kapital i rezerve',
    subtractionReturns: 'Rezerve iz dobiti',
    revalorizationReserves: 'Revalorizacijske rezerve',
    justValueReserves: 'Rezerve fer vrijednosti',
    minorityInterest: 'Manjinski nekontrolirajući interes',
    reservations: 'Rezerviranja',
    balanceReservations: 'Rezerviranja',
    pensionsReserves: 'Rezerviranja za mirovine, otpremnine i slične obveze',
    taxReserves: 'Rezerviranja za porezne obveze',
    otherReserves: 'Druga rezerviranja',
    otherLongTermObligations: 'Ostale dugoročne obveze',
    delayedExpensesPayments: 'Odgođeno plaćenje troškova i prihod budućeg poslovanja',
    extraBalance: 'Izvanbilančni zapisi',
    activeExtraBalance: 'Aktiva Izvanbilančni zapisi',
    passiveExtraBalance: 'Pasiva Izvanbilančni zapisi',
    position: 'Pozicija',
    assets: 'Aktiva',
    fullAssets: 'Aktiva',
    liabilities: 'Pasiva',
    adittionalCoefficientOfFinancialStabilty: 'Dodatni koeficijent financijske stabilnosti',
    indebtednessFactor: 'Faktor zaduženosti',
    accumulatedAmortization: 'Akumulirana amortizacija',
    productMaterialGoodsStocks: 'Zalihe proizvoda, robe, materijala',
    stockDays: 'Zalihe proizvoda, robe, materijala',
    productStock: 'Zalihe sirovina',
    subCapital: 'Upisani kapital',
    subscribedCapital: 'Upisani kapital',
    earningLossCarried: 'Zadržana dobit ili preneseni gubitak',
    keptProfitOrTransferredLoss: 'Zadržana dobit ili preneseni gubitak',
    retainedEarnings: 'Zadržana dobit',
    keptProfit: 'Zadržana dobit',
    lossCarried: 'Preneseni gubitak',
    transferredLoss: 'Preneseni gubitak',
    profitLossByYear: 'Dobit / gubitak poslovne godine',
    balanceProfit: 'Dobit / gubitak poslovne godine',
    profitBusinessYear: 'Dobit poslovne godine',
    lossBusinessYear: 'Gubitak poslovne godine',
    longTermObligations: 'Dugoročne obveze',
    bankLiabilities: 'Obveze prema bankama',
    bankDebt: 'Obveze prema bankama',
    bankAndOtherObligations: 'Obveze prema bankama i ostalim financijskim institucijama',
    defferedPaymentOfExp: 'Odgođeno plaćanje troškova i prihod budućeg razdoblja',
    loanObligations: 'Obveze za zajmove, depozite i slično',
    shorttermLiabilities: 'Kratkoročne obveze',
    shortTermObligations: 'Kratkoročne obveze',
    supplierCommitments: 'Obveze prema dobavljačima',
    suppliersDays: 'Obveze prema dobavljačima',
    employeeCommitments: 'Obveze prema zaposlenicima',
    employeesObligations: 'Obveze prema zaposlenicima',
    otherShorttermCommitments: 'Ostale kratkoročne obveze',
    otherShortTermObligations: 'Ostale kratkoročne obveze',
    //Postojeća imovina poduzetnika
    availableAssetsSpec: 'Specifikacija raspoložive imovine',
    previousAssetsNotProject: 'Imovina iz prethodnog razdoblja koja nije nabavljena putem projekta',
    projectHolder: 'Information on the Investor / Project Holder',

    estimateValues: 'Predračunske vrijednosti ulaganja',
    addItem: 'Dodaj stavku',

    researchAndDevelopment: 'Istraživanje i razvoj',
    concessions: 'Koncesije',
    patents: 'Patenti',
    phoneServices: 'Telefonske usluge',
    brands: 'Robne i uslužne marke',
    software: 'Software',

    land: 'Zemljišta',
    buildings: 'Građevinski objekti',
    facilities: 'Postrojenja',
    equipment: 'Oprema',
    tools: 'Alati',
    inventory: 'Inventar',
    transport: 'Transportna sredstva',
    plants: 'Biološka imovina - bilje',
    animals: 'Biološka imovina - životinje',

    externalServices: 'Vanjske usluge',
    material: 'Materijal',
    intellectualServices: 'Intelektualne usluge',
    otherExternalServices: 'Ostale vanjske usluge',
    representation: 'Reprezentacija',
    procurement: 'Nabava robe',
    nonMaterialStructure: 'Struktura nematerijalnih sredstava',
    materialStructure: 'Struktura materijalnih sredstava',
    workingCapitalStructure: 'Struktura obrtnih sredstava',
    investmentStructure: 'Struktura ulaganja',
    investmentBudget: 'Proračun troškova ulaganja',
    investmentBudgetNotif: 'Popunjavati samo u slučaju korištenja bespovratnih sredstava',
    materialInvestment: 'Ulaganja u materijalnu imovinu',
    nonMaterialInvestment: 'Ulaganja u nematerijalnu imovinu',
    investmentSources: 'Plan izvora sredstava',

    investorInfo: 'Podaci o Investitoru/Nositelju projekta',
    companyName: 'Naziv tvrtke',
    companyResidence: 'Sjedište / Adresa',
    oib: 'OIB',
    personResponsible: 'Ime i prezime odgovorne osobe',
    contactName: 'Ime i prezime kontakt osobe',
    contactPhone: 'Kontakt telefon',
    projectInfo: 'Podaci o projektu',
    projectLocation: 'Lokacija projekta',
    investmentType: 'Karakter ulaganja',
    goal: 'Cilj',
    timelinePlan: 'Terminski plan provedbe',
    madeBy: 'Pripremio/la',

    materialAssets: 'Dugotrajna materijalna imovina',
    nonMaterialAssets: 'Nematerijalna imovina',
    workingCapital: 'Obrtna sredstva',
    sumProjectInvestment: 'Ukupna ulaganja u projekt',


    foreignLongTermInvestment: 'Tuđi dugorčni kapital',
    creditAssets: 'Kreditna sredstva',
    nonrefundableAssets: 'Nepovratna sredstva',
    ownersCapital: 'Vlastiti kapital osnivača',

    //LOAN
    loan: 'Kredit',

    location: 'Lokacija',
    locationAnalysis: 'Analiza lokacije',
    environmentProtection: 'Zaštita čovjekove okoline',
    environmentEffects: 'Utjecaj projekta na okoliš',
    investmentRealization: 'Dinamika realizacije ulaganja',
    workDynamics: 'Analiza izvodljivosti projekta i dinamika rada',
    marketingPlan: 'Marketing plan',
    marketingActivitiesPlan: 'Plan marketinških aktivnosti i proračun troškova',
    marketingReport: 'Marketing izvještaj',
    financialAnalysis: 'Financijska analiza',
    basicInstrumentsEstimation: 'Predračunska vrijednost ulaganja u osnovna sredstva',
    basicInstrumentsStructure: 'Struktura osnovnih sredstava',

    workingCapitalEstimation: 'Predračunska vrijednost potrebnih obrtnih sredstava',
    outsourceManufacturing: 'Vanjske usluge izrade',
    otherOutsourceServices: 'Ostale vanjske usluge',
    merchProcurement: 'Nabava robe',
    otherNonmaterialExpenses: 'Ostali nematerijalni troškovi',

    businessField: 'Predmet poslovanja poduzetnika',
    currentAssets: 'Postojeća imovina poduzetnika',
    currentFinancialAnalysis: 'Financijska analiza dosadašnjeg poslovanja',
    developmentProspect: 'Ocjena razvojnih mogućnosti ulagatelja',

    moneyAmount: 'Iznos',
    sum: 'Ukupno',
    passiveSum: 'Pasiva ukupno',
    sumAllYears: 'Ukupno za sve godine',
    for: 'za',
    showsValue: 'pokazuje vrijednost',

    nonMaterialExpenses: 'Nematerijalni troškovi',
    nonMaterialOtherExpenses: 'Nematerijalni i ostali troškovi',
    materialExpenses: 'Materijalni troškovi',
    materialExpense: 'Materijalni troškovi',
    rawMaterialExpenses: 'Troškovi sirovina i materijala',
    energyExpenses: 'Troškovi energije',
    otherMaterialExpenses: 'Ostali materijalni troškovi',
    merchandiseSalesExpenses: 'Troškovi prodane robe',
    serviceExpenses: 'Troškovi usluga',
    serviceExpense: 'Troškovi usluga',
    transportServices: 'Transport',
    maintenanceServices: 'Održavanje',
    registrationServices: 'Registracija',
    leasingServices: 'Usluge leasinga',
    communalServices: 'Komunalne usluge',
    representationServices: 'Reprezentacija',
    otherExpenses: 'Ostali troškovi',
    travelExpenses: 'Putovanja',
    compensationExpenses: 'Naknade troškova, darovi i potpore',
    administrationExpenses: 'Troškovi članova uprave',
    internalRepresentationExpenses: 'troškovi reprezentacije i promidžbe (interne)',
    insurancePremiums: 'Premije osiguranja',
    bankingServices: 'Bankovne usluge i troškovi platnog prometa',
    membershipExpenses: 'Članarine, naknade i slična davanja',
    independentTaxes: 'Porezi neovisni o dobitku i postrojbe',
    rightToUseExpenses: 'Troškovi prava korištenja',
    addExpense: 'Dodaj trošak',
    expense: 'Trošak',
    expenses: 'Troškovi',
    unit: 'Mjerna jedinica',
    costPerUnit: 'Trošak po jedinici',

    productExpenses: {
      productionMaterial: 'Materijal izrade',
      productionSalary: 'Plaća izrade',
      partnerServices: 'Usluge kooperanata',
      amortization: 'Amortizacija',
      generalProductionCosts: 'Opći troškovi izrade',
      generalManagementCosts: 'Opći troškovi uprave',
      generalSalesCosts: 'Opći troškovi prodaje',
      generalDevelopmentCosts: 'Opći troškovi razvoja proizvoda',
    },

    addAmortizationItem: 'Dodaj imovinu',
    expensesCalculation: 'Proračun troškova i kalkulacija cijena',
    incomeTax: 'Porez na dobit',


    //FLOWS
    financeFlow: 'Financijski tijek',
    economyFlow: 'Ekonomski tijek',
    cashFlow: 'Novčani tijek',
    receipts: 'Primici',
    fullIncomeWOSubsidies: 'Ukupan prihod',
    pureNetIncomes: 'Čisti neto primitak',
    ownSources: 'Vlastiti izvori',
    existingSourcesTransfer: 'Prijenos postojećih izvora',
    restOfProjectValue: 'Ostatak vrijednosti projekta',
    longTermAssets: 'Dugotrajna imovina',
    fixedAssets: 'Dugotrajna imovina',
    fleetingAssets: 'Kratkotrajna imovina',
    outlays: 'Izdaci',
    transferOfExistingAssets: 'Prijenos postojeće imovine',
    investments: 'Ulaganja',
    materialServicesCosts: 'Troškovi materijala i usluga',
    longTermAssetsInvestment: 'Ulaganja u dugotrajnu imovinu',
    otherShortTermInvestment: 'Ostala ulaganja u kratkotrajnu imovinu',
    materialAndNonMaterialExpenses: 'Materijalni i nematerijalni troškovi',
    staffExpenses: 'Troškovi osoblja',
    staffExpense: 'Troškovi osoblja',
    financialExpense: 'Financijski rashodi',
    specialExpenses: 'Izvanredni reshodi',
    loanAnnuity: 'Anuitet',
    loanPrincipal: 'Glavnica kredita',
    netIncomes: 'Neto primici',
    costMaterial: 'Materijalni trošak',
    costNonMaterial: 'Nematerijalni trošak',
    basicMeans: 'Osnovna sredstva',
    salesProduct: 'Prodaja proizvoda',
    LicenseAndGoods: 'Roba i licenca',
    fundsOwn: 'Vlastita sredstva',
    creditBICRO: 'Kredit BICRO',
    fundsNoNRefundable: 'Nepov. sred. BICRO',
    cumulative: 'Kumulativ',
    incomesFromOtherSubsidies: 'Primici od ostalih potpora',
    loans: 'Krediti',
    ebitda: 'EBITDA',


    //MARKET RATING
    marketRating: 'Ekonomsko tržišna ocjena',
    staticEfficiencyRating: 'Statička ocjena efikasnosti investicijskog projekta',
    dynamicRating: 'Dinamička  ocjena projekta',
    roiMethod: 'Metoda razdoblja povrata investicijskog ulaganja',
    netValueMethod: 'Metoda neto sadašnje vrijednosti',
    relativeValueMethod: 'Metoda relativne sadašnje vrijednosti',
    internalRentabilityMethod: 'Metoda interne stope rentabilnosti (IRR)',
    internalProfitabilityMethod: 'Metoda interne stope profitabilnosti',
    pureEconomicIncome: 'Čisti primici ekonomskog tijeka',
    discountFactor: 'Diskontni faktori',
    discount: 'Diskont',
    projectYear: 'Godina projekta',
    yearAmount: 'Godišnji iznos',
    nsv: 'NSV',
    currentProjectValueTwo: 'Sadašnja vrijednost projekta',
    profitabilityIndex: 'Indeks rentabilnosti',

    //INDICATORS
    indicators: 'Indikatori',
    liquidityIndicators: 'Pokazatelji likvidnosti',
    currentRatio: 'Koeficijent tekuće likvidnosti',
    quickRatio: 'Koeficijent ubrzane likvidnosti',
    cashLiquidity: 'Koeficijent trenutne likvidnosti',
    debtIndicators: 'Pokazatelji zaduženosti',
    debtRatio: 'Stupanj zaduženosti',
    equityRatio: 'Stupanj samofinanciranja',
    financialCoefficient: 'Koeficijent financiranja',
    debtFactor: 'Faktor zaduženosti (broj godina)',
    financialAssetsOwnSourcesCover: 'Stupanj pokrića dugotrajne imovine vlastitim izvorima',
    financialAssetsLongTermSourcesCover: 'Stupanj pokrića dugotrajne imovine dugoročnim izvorima',
    financialStabilityRatio: 'Koeficijent financijske stabilnosti',
    salesIncomeAssetTurnover: 'Koeficijent obrtaja aktive na temelju prihoda od prodaje',
    receivableTurnoverRatio: 'Koeficijent obrtaja potraživanja',
    sumIncomeAssetTurnover: 'Koeficijent obrtaja ukupne imovine',
    fleetingAssetsTurnover: 'Koeficijent obrtaja kratkotrajne imovine',
    shortTermClaimsPaymentTime: 'Dani naplate potraživanja od kupaca',
    buyersClaimsPaymentTime: 'Vrijeme naplate potraživanja od kupaca, u danim',
    suppliersPaymentDays: 'Dani plaćanja obaveza dobavljačima',
    inventoryBindingDays: 'Dani vezivanja zaliha',
    sumBusinessCostEffectiveness: 'Ekonomičnost ukupnog poslovanja ',
    regularBusinessCostEffectiveness: 'Ekonomičnost redovnog poslovanja',
    grossCirculationRentability: 'Rentabilnost prometa bruto (Profitna marža - bruto)',
    netCirculationRentability: 'Rentabilnost prometa neto (Neto profitna marža)',
    grossSumAssets: 'Rentabilnost ukupne imovine bruto',
    sumAssetsRentability: 'Rentabilnost ukupne imovine neto (ROA)',
    ownCapitalRentability: 'Rentabilnost vlastitog kapitala (ROE)',
    ebitMargin: 'EBIT marža',
    ebitOperativeResult: 'EBIT - Operativni rezultat',
    ebitaMargin: 'EBITDA marža',
    ebita: 'EBITDA ',
    newlyCreatedValue: 'Novostvorena vrijednost',
    additionalFinancialStabilityRatio: 'Dodatni koeficijent financijske stabilnosti',
    activityIndicators: 'Pokazatelji aktivnosti',
    assetTurnover: 'Koeficijent obrtaja aktive na temelju prihoda od prodaje',
    profitabilityIndicators: 'Indikatori profitabilnosti',
    profitabilityIndicatorsTwo: 'Pokazatelji profitabilnosti',
    profitMargin: 'Profitna marža',
    netProfitMargin: 'Neto profitna marža',
    returnOnSales: 'Neto profitna marža na prihod od prodaje',
    netAssetRentability: 'Neto rentabilnost imovine',
    grossAssetRentability: 'Bruto rentabilnost imovine',
    principalRentability: 'Rentabilnost glavnice',
    chooseYears: 'Izaberite godinu',
    choose:'Izabrana godina',

    //DYNAMIC PROJECT RATING
    dynamicProjectRating: 'Dinamička ocjena projekta',
    returnOfInvestmentMethod: 'Metoda razdoblja povrata investicijskog ulaganja',
    investment: 'Investicija',
    accumulation: 'Akumulacija - neto primici',
    uncoveredAmount: 'Nepokriveni dio',
    yearly: 'Godišnje',
    cumulatively: 'Kumulativno',
    ROIBreakthrough: (amount: number, year: number) => `Razdoblje povrata uloženih sredstava u godinama:  ${amount}`,

    //Analiza osjetljivosti'
    sensitivityAnalysis: 'Analiza osjetljivosti',
    projectSensitivityAnalysis: 'Analiza osjetljivosti projekta',

    //Pokazatelji uspješnosti
    successIndicators: 'Pokazatelji uspješnosti',
    breakeven: 'Točka pokrića',

    //Zaključak
    conclusion: 'Zaključak',
    finalRating: 'Zaključna ocjena projekta',

    no: 'r.b.',

    //PROJECT DEFINING
    riskAnalysis: 'Analiza rizika',
    low: 'Nisko',
    intermediate: 'Srednje',
    high: 'Visoko',
    applicantImplementationCapacity: 'Provedbeni kapaciteti prijavitelja',
    techInvestmentElements: 'Tehnički elementi ulaganja',
    techProcess: 'Opis tehničko-tehnološkog procesa',
    techMaterialsAndEnergy: 'Utrošak sirovina, materijala i energenata',
    techInvestmentStructure: 'Opis tehničko-tehnološkog projekta',
    buildingsCharacteristics: 'Karakteristike građevinskog projekta / poslovni prostor',
    techCapacity: 'Tehnološki kapacitet i obujam proizvodnje',
    plannedProduction: 'Planirani kapacitet i struktura proizvodnje',
    productOrService: 'Proizvod/usluga',
    amountAndPrices: 'Količine i cijene',
    price: 'Cijena',
    yearlyPlannedAmounts: 'Godišnje planirane količine',
    yearlyPlannedPrices: 'Godišnje planirane cijene',
    yearlyPlannedIncome: 'Godišnji planirani prihodi',
    businessIncomeFormation: 'Formiranje poslovnih prihoda',
    productsSum: 'Proizvodi ukupno',
    servicesSum: 'Usluge ukupno',
    planedAmountCost: 'Planirane količine i cijene po godinama',
    planedCostPerYear: 'Planirane cijene po godinama',
    projectExperience: 'Projektno iskustvo prijavitelja',
    projectTeamEstablishment: 'Metodologija uspostave projektnog tima',
    applicantGeneral: 'Opći podaci o prijavitelju',
    targetMarket: 'Ciljano tržište',
    marketingMix: 'Oblikovanje marketing miksa',
    marketingActivityPlan: 'Plan uvođenja marketinških aktivnosti',
    strength: 'Snaga',
    weakness: 'Slabosti',
    oportunities: 'Prilike',
    threats: 'Prijetnje',
    problemAnalysis: 'Analiza problema',
    projectFormulation: 'Formulacija projektnog prijedloga',
    projectIndicators: 'Pokazatelji',
    projectSector: 'Sektor u kojem se provodi projekt',
    techInvestment: 'Tehnička struktura ulaganja',
    risk: 'Rizik',
    probability: 'Vjerojatnost',
    influence: 'Utjecaj',
    mitigateRisk: 'Mjere ze ublažavanje ili izbjegavanje rizika',
    internalRisks: 'Unutarnji rizici',
    externalRisks: 'Vanjski rizici',

    materialProductionInputs: 'Materijalni inputi proizvodnje / Utrošak sirovina, materijala, energenata',
    projectCommercialSustainability: 'Komercijalna održivost projekta',

    //BASIC INFORMATION
    basicInformation: 'Osnovni podatci o prijavitelju',

    graphs: 'Grafički pokazatelji',
    incomes: 'Prihodi',
    incomesStructure: 'Struktura prihoda',
    expensesStructure: 'Struktura rashoda',
    incomesAndExpenses: 'Prihodi i rashodi',

    projection: 'Projekcija',
    confirm: 'Potvrdi',
    cancel: 'Odustani',

    // PROJECT REALIZATION
    planed: 'Planirano',
    realized: 'Realizirano',
    customerIncome: 'Novčani primici od kupca',
    commissionsIncome: 'Novčani primici od tantijema, naknada, provizija i sl.',
    insuranceIncome: 'Novčani primici od osiguranja za naknadu šteta',
    taxReturnIncome: 'Novčani primici s osnove povrata poreza',
    supplierExpense: 'Novčani izdaci dobavljača',
    employeeExpense: 'Novčani izdaci za zaposlene',
    insuranceExpense: 'Novčani izdaci za osiguranje za naknadu šteta',
    otherIncomeExpense: 'ostali novčani primici i izdaci',
    businessMoney: 'Novac iz poslovanja',
    interestExpense: 'Novčani izdaci za kamate',
    paidIncomeTax: 'Plaćeni porez na dobit',
    operatingActivityCashFlow: 'Neto novčani tokovi od poslovnih aktivnosti',
    longTermAssetsIncome: 'Novčani primici od prodaje dugotrajne materijalne i nematerijalne imovine',
    financeIncome: 'Novčani primici od prodaje financijskih instrumenata',
    interestCashIncome: 'Novčani primici od kamata',
    dividendsIncome: 'Novčani primici od dividendi',
    loanSavingsIncome: 'Novčani primici s osnove povrata danih zajmova i štednih uloga',
    investmentActivityIncome: 'Ostali novčani primici od investicjskih aktivnosti',
    investmentActivityIncomeTotal: 'Ukupno novčani primici od investicjskih aktivnosti',
    longTermAssetsExpense: 'Novčani izdaci za kupnju dugotrajne materijalne i nematerijalne imovine',
    financialExpenses: 'Novčani izdaci za stjecanje financisjkih instrumenata',
    loanSavingsExpense: 'Novčani izdaci s osnove danih zajmova i štednih uloga',
    subsidiary: 'Stijecanje ovisnog društva, umanjeno za stečeni novac',
    investmentActivityExpense: 'Ostali novčani izdaci od investicijskih aktivnosti',
    investmentActivityExpenseTotal: 'Ukupno novčani izdaci od investicijskih aktivnosti',
    investmentActivityCashFlow: 'Neto novčani tokovi od investicijskih aktivnosti',
    coreCapitalIncome: 'Novčani primici od povećanja temeljnog (upisanog) kapitala',
    financialEquityDebtIncome: 'Novčani primici od izdavanja vlasničkih i dužničkih financijskih instrumenata',
    loanPrincipalIncome: 'Novčani primici od glavnice kredita, pozajmica i drugih posudbi',
    financialActivityIncome: 'Ostali novčani primici od financijskih aktivnosti',
    financialActivityIncomeTotal: 'Ukupni novčani primici od financijskih aktivnosti',
    loanPrincipalExpense: 'Novčani izdaci za otplatu glavnice kredita, pozajmica i drugih posudbi',
    dividendsExpense: 'Novčani izdaci za isplatu dividendi',
    financialLeasesExpense: 'Novčani izdaci za financijski najam',
    coreCapitalExpense: 'Novčani izdaci za otkup vlastitih dionica i smanjenje temeljnog kapitala',
    financialActivityExpense: 'Ostali novčani izdaci od financijskih aktivnosti',
    financialActivityExpenseTotal: 'Ukupni novčani izdaci od financijskih aktivnosti',
    financialActivityCashFlow: 'Neto novčani tokovi od financijskih aktivnosti',
    exchangeRateDifference: 'Nerealizirane tečajne razlike po novcu i novčanim ekvivalentima',
    cashFlowDifference: 'Neto povečanje/smanjenje novčanih tokova',
    startCoreCash: 'Novac i novčani ekvivalenti na početku razdoblja',
    endCoreCash: 'Novac i novčani ekvivalenti na kraju razdoblja',

  }
};
